import { FormConfig, FormState } from "@components/PatientForms/FormContext/types";
import { ReviewOfSystemsData } from "src/revamp/types/PatientFormTypes";
import { z } from "zod";

export const measurementsSchema = [
	{
    type: "toggle-buttons",
    name: "unit",
		label: "Unit",
		options: [
			{ value: "Imperial", label: "Imperial" },
			{ value: "Metric", label: "Metric" },
		],
		fieldProps: {
			labelProps: {
				sx: { fontWeight: "bold", color: "text.primary" },
			},
    },
  },
  {
    type: "group-input",
    name: "height",
    title: "Height",
    group: [
      {
        type: "numeric",
        name: "height.feet",
        label: "ft",
				fieldProps: {
					decimalScale: 0,
				},
				conditional: {
					label: "unit",
					values: ["Imperial"],
					resetOnHide: true,
				},
				rule: z.string().regex(/\d/),
      },
      {
        type: "numeric",
        name: "height.inches",
        label: "in",
				fieldProps: {
					decimalScale: 0,
				},
				conditional: {
					label: "unit",
					values: ["Imperial"],
					resetOnHide: true,
				},
				rule: z.string().regex(/\d{1,2}/),
      },
			{
				type: "numeric",	
				name: "height.cm",
				label: "cm",
				fieldProps: {
					sx: { width: { xs: "100%", md: "50%" } },
					decimalScale: 0,
				},
				conditional: {
					label: "unit",
					values: ["Metric"],
					resetOnHide: true,
				},
				rule: z.string().regex(/\d{2,3}/),
			},
		],
	},
	{
		type: "group-input",
		name: "weight",
		title: "Weight",
		group: [
			{
				type: "numeric",
				name: "weight.pounds",
				label: "Pounds",
				fieldProps: {
					endAdornment: "lbs",
					decimalScale: 0,
				},
				conditional: {
					label: "unit",
					values: ["Imperial"],
					resetOnHide: true,
				},
				rule: z.string().regex(/\d{1,3}/),
			},
			{
				type: "numeric",
				name: "weight.kg",
				label: "kg",
				fieldProps: {
					endAdornment: "kg",
					decimalScale: 0,
				},
				conditional: {
					label: "unit",
					values: ["Metric"],
					resetOnHide: true,
				},
				rule: z.string().regex(/\d{1,3}/),
			},
		],
	}
];

export const recentSymptomsSchema = [
	{
		type: "multi-select",
		name: "recentSymptoms",
		title: "Recent Symptoms",
		description: "Select all of the following symptoms you have experienced in the last few weeks.",
		options: [
			'Skin rash',
			'Sores',
			'Excessive bruising',
			'Excessive thirst',
			'Excessive urination',
			'Significant headaches',
			'Double or blurred vision',
			'Diminished hearing',
			'Dizziness',
			'Sinus problems',
			'Cough',
			'Shortness of breath',
			'Wheezing',
			'Asthma',
			'Coughing up sputum or blood',
			'Blackouts or loss of consciousness',
			'Chest pain or pressure',
			'Rapid or irregular heart beats',
			'Abnormal swelling in legs or feet',
			'Pain in calves when you walk',
			'Difficulty swallowing',
			'Heartburn',
			'Nausea',
			'Vomiting',
			'Significant problems with constipation',
			'Diarrhea',
			'Fever',
			'Large lymph nodes',
			'Weight loss/gain of more than 10 pounds (last 6 months)',
			'Experiencing an unusually stressful situation',
		].map((symptom) => ({ label: symptom, value: symptom }))
	}
];

export const currentHealthSchema = [
	...measurementsSchema,
	...recentSymptomsSchema,
];

export const emptyRecentSymptoms = (data: ReviewOfSystemsData, formState: FormState, formConfig: FormConfig) => {
	console.log("setting recent symptoms to empty array")
	if (!formState.completedSteps.includes("physiology-review") && !formConfig.allowSkipSteps) {
		data.recentSymptoms = [];
	}
}
	

export default currentHealthSchema;